import { lazy, Suspense, memo, useEffect, useState } from "react";

interface IconProps {
  name: string;
  size?: number | 'size-auto';
	className?: string;
  [key: string]: any;
}

const Icon = memo(({ name, size = 24, className, ...otherProps }: IconProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [IconComponent, setIconComponent] = useState<any>(null);

  useEffect(() => {
    let mounted = true;
    
    const loadIcon = async () => {
      try {
        const module = await import(`@assets/icons/${name}`);
        if (mounted) {
          setIconComponent(() => module.default);
          setIsLoaded(true);
        }
      } catch (error) {
        console.error(`Failed to load icon: ${name}`, error);
        if (mounted) {
          setIsLoaded(false);
        }
      }
    };

    loadIcon();

    return () => {
      mounted = false;
    };
  }, [name]);

  return (
    <i className={`icon icon-${size} icon-component ${className} ${isLoaded ? "icon-loaded" : ""}`}>
      <Suspense fallback={null}>
        {IconComponent && <IconComponent {...otherProps} size={size} />}
      </Suspense>
    </i>
  );
});

export default Icon;
